export class Rental {
    id!: string
    equipment!: string
    vendorId!: number
    jobId!: string
    rentedById!: number
    pickedUpById!: number
    pickedUpDate!: Date
    scheduledReturnDate!: Date
    returnedDate!: Date
    vendorMaintains!: boolean
    fuelType!: string
    billingCycle!: number
    rate!: number
    rateUnit!: number
    hoursStart!: number
    hoursEnd!: number
    isRpo!: boolean
    rpoEquipNum!: string
    serialNum!: string

    imageUrls!: string[]
}
